import { SchedulerDateSelector } from "./SchedulerDateSelector";

interface Props {
  /** "YYYY-MM-DD" */
  date: string;
  onSelectDate: (date: string) => void;
  onShift: (days: number) => void;
}

export function SchedulerHeader({ date, onSelectDate, onShift }: Props) {
  return (
    <div className="flex flex-wrap items-start justify-between" style={{ gap: 16 }}>
      <div>
        <h1 className="font-bold text-foreground" style={{ fontSize: 28, lineHeight: 1.2 }}>
          Channel Scheduler
        </h1>
        <p className="text-sm text-muted-foreground" style={{ marginTop: 4 }}>
          Plan your 24/7 channels using your existing content. Drag and drop to schedule. Changes
          save automatically.
        </p>
      </div>
      <SchedulerDateSelector date={date} onSelectDate={onSelectDate} onShift={onShift} />
    </div>
  );
}
